/// <reference types="./vite-env.d.ts" />
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '../server/trpc';
import { getUserId } from './lib/userIdentity';
import { authClient } from './lib/auth-client';
import { authFetch, waitForAuth } from './lib/auth-fetch';

const API_URL = '/api/v1';

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: API_URL,
      // Use authFetch to wait for auth and retry on 401
      fetch: authFetch,
      async headers() {
        // Wait for auth to be ready so we get the token
        await waitForAuth();

        const session = await authClient.getSession();
        const headers: Record<string, string> = {
          'X-Canvibe-User-Id': getUserId(),
        };

        if (session.data?.session?.token) {
          headers['Authorization'] = `Bearer ${session.data.session.token}`;
        }

        return headers;
      },
    }),
  ],
});
